import { FlashList, FlashListRef } from '@shopify/flash-list'
import { cssInterop } from 'nativewind'

cssInterop(FlashList, {
  className: 'style',
  contentContainerClassName: 'contentContainerStyle'
})

export { FlashList, FlashListRef }
